'use strict';

const {Pagination} = require("../../../../../../custom_components/js/warehouse/client/Product");
module.exports = (app) => app.controller('clientWarehouseProductSearchController', /* @ngInject */ function ($scope, clientWarehouseService, translationService) {

    $scope.init = init;

    /**
     * @type {ProductSearchResult[]}
     */
    $scope.products = [];

    /**
     * @type {Pagination}
     */
    $scope.page = new Pagination(0, 50);

    $scope.loadData = loadData;
    $scope.setPage = setPage;

    let tabLabelId;

    function init(tabId, query) {
        $scope.query = query.trim();
        tabLabelId = tabId;
        loadData($scope.page.elementsPerPage, $scope.page.page);
    }

    function setPage(page) {
        $scope.page.page = page - 1;
        loadData($scope.page.elementsPerPage);
    }

    function loadData(pageSize, page) {
        if(pageSize) {
            $scope.page.elementsPerPage = pageSize;
        }
        if(page) {
            $scope.page.page = page;
        }
        clientWarehouseService.searchProducts($scope.query, $scope.page.page, $scope.page.elementsPerPage).then(
            /**
             * @param result {PaginationResponse}
             */
            (result) => {
                $scope.products = result.data;
                $scope.page.totalPages = result.pagination.totalPages;
                $scope.page.totalEntries = result.pagination.totalEntries;
                updateTabTitle();
                $scope.$apply();
            })
    }

    function updateTabTitle() {
        const title = _('Lagerartikel');
        window.require(["dijit/registry", "dojo/request"], function (registry) {
            const tab = registry.byId(tabLabelId)
            if (tab) {
                const str = `${translationService.translate(title)} ${($scope.products?.length ?? 0).toString()}`;
                tab.set('title', str)
            }

        });
    }
});

